import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=4765e61e&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=4765e61e&prod&lang=scss"
import style1 from "./HelloWorld.vue?vue&type=style&index=1&id=4765e61e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4765e61e",
  null
  
)

export default component.exports